/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const keyPrefix = "supplier_system";
export function getItem(key: string): any {
  let res = null;
  try {
    res = JSON.parse(sessionStorage.getItem(keyPrefix + key) + "");
  } catch (err) {
    res = sessionStorage.getItem(keyPrefix + key);
  }
  return res;
}
export function setItem(key: string, value: any): void {
  sessionStorage.setItem(keyPrefix + key, JSON.stringify(value));
}
